module.exports = __webpack_public_path__ + "img/delete.1a8c16a1.svg";